import React, { useEffect, useState } from 'react';
import { Toast } from '@shared/ui/toast/toast';
import { Typography } from '@shared/ui/typography/typography';
import { Button } from '@vtbhome/juicyfront';
import { AllSuccess } from '@vtbhome/juicyfront/indexIcon';
import toast from 'react-hot-toast';
import { ModalConfirm } from './modal-confirm/modal-confirm';
import { ApproveManagerRequestProps } from './types';
import { useApproveRequestMutation } from '@features/request/decline-manager-request/api/request-api';
import { CACHE_KEY_REQUEST_APPROVE } from '../config/api-constants';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { DISABLED_STATUSES } from '../config/disabled-statuses';

export const ApproveManagerRequest: React.FC<ApproveManagerRequestProps> = ({
    request,
    displayButtonText,
    onSuccess,
}) => {
    const [, rejectRequestResult] = useApproveRequestMutation({ fixedCacheKey: CACHE_KEY_REQUEST_APPROVE });
    const [isShowModal, setIsShowModal] = useState(false);
    const isDisabled = DISABLED_STATUSES.includes(request.status);

    const handleClose = () => {
        setIsShowModal(false);
    };

    useEffect(() => {
        if (isShowModal && rejectRequestResult.isSuccess) {
            onSuccess();
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description={'Запрос на регистрацию одобрен'}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            rejectRequestResult.reset();
        } else if (isShowModal && rejectRequestResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось одобрить запрос на регистрацию.\n${getQueryError(rejectRequestResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            rejectRequestResult.reset();
        }
    }, [isShowModal, rejectRequestResult.isSuccess, rejectRequestResult.isError]);

    return (
        <>
            <Button
                disabled={isDisabled}
                size='s'
                buttonType='light'
                startAdornment={<AllSuccess size='xxs' />}
                onClick={() => setIsShowModal(true)}>
                {displayButtonText && (
                    <Typography size='button2' color='inherit'>
                        Согласовать
                    </Typography>
                )}
            </Button>
            <ModalConfirm isShow={isShowModal} request={request} onClose={handleClose} onConfirm={handleClose} />
        </>
    );
};
